import { useCallback } from 'react';

import { ListEntityType } from 'src/services/lists/lists.types';
import { CsvImportRow, CsvImportOptions } from 'src/services/common.types';
import { CustomFieldEntityType } from 'src/services/custom-fields/custom-field.types';
import { useBulkCompanyImportMutation } from 'src/services/connections/connections.service';

import CsvImportDialog, { CsvImportResult } from 'src/sections/import/csv-import-dialog';

type Props = {
  organizationId?: string | undefined;
  open: boolean;
  onClose: VoidFunction;
};

const resultLabel = (result: CsvImportResult) => result.companyName ?? '';

export default function BulkCompanyImportModal({ organizationId, open, onClose }: Props) {
  const [bulkCompanyImport, { isLoading }] = useBulkCompanyImportMutation();

  const handleImport = useCallback(
    (rows: CsvImportRow[], options: CsvImportOptions) =>
      bulkCompanyImport({ data: { organization_id: organizationId, companies: rows, ...options } }).unwrap(),
    [bulkCompanyImport, organizationId]
  );

  return (
    <CsvImportDialog
      open={open}
      onClose={onClose}
      organizationId={organizationId}
      entity="company"
      customFieldEntityType={CustomFieldEntityType.COMPANY}
      listEntityType={ListEntityType.COMPANY}
      i18nPrefix="companies.bulk_import_modal"
      templateFileName="Company Import Template.csv"
      isImporting={isLoading}
      onImport={handleImport}
      resultLabel={resultLabel}
    />
  );
}
